const PIXEL_ID = '870739235966399'

declare global {
  interface Window {
    fbq?: (...args: any[]) => void
    _fbq?: any
  }
}

let initialized = false

/**
 * Injects the official Meta Pixel base code and initializes the pixel.
 * Safe to call multiple times — only runs once.
 */
export function initMetaPixel(): void {
  if (typeof window === 'undefined' || initialized) return /* eslint-disable */
  ;(function (f: any, b: Document, e: string, v: string) {
    if (f.fbq) return
    const n: any = (f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    })
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []
    const t = b.createElement(e) as HTMLScriptElement
    t.async = true
    t.src = v
    const s = b.getElementsByTagName(e)[0]
    if (s && s.parentNode) {
      s.parentNode.insertBefore(t, s)
    } else {
      ;(b.head || b.documentElement).appendChild(t)
    }
  })(
    window,
    document,
    'script',
    'https://connect.facebook.net/en_US/fbevents.js',
  )
  /* eslint-enable */

  window.fbq?.('init', PIXEL_ID)
  initialized = true
}

/** Fire a standard PageView event. */
export function trackPageView(): void {
  window.fbq?.('track', 'PageView')
}

/** Fire a standard AddToCart event. */
export function trackAddToCart(params?: Record<string, unknown>): void {
  window.fbq?.('track', 'AddToCart', params)
}
